import { TextV2 } from '@dealstack/frontend/shared/components/TextV2/TextV2';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { em } from '@mantine/core';
import styled, { css } from 'styled-components';

interface IScrollableSection {
	scrollTotalSize: number;
}

export const ScrollableSection = styled.div<IScrollableSection>`
	width: ${({ scrollTotalSize }) => `${scrollTotalSize}px`};
	min-width: ${({ scrollTotalSize }) => `${scrollTotalSize}px`};
	position: relative;
	height: 4.875rem;
`;
export const DropdownDeleteField = styled.div`
	display: contents;
	cursor: pointer;
`;
const MenuItemText = styled(TextV2)`
	color: ${({ theme }) => theme.v2.color.neutral[700]};
	padding: 0.25em;
`;
export const RedText = styled(MenuItemText)`
	${({ disabled, theme }) =>
		disabled
			? css`
					cursor: not-allowed;
					color: ${theme.v2.color.neutral[500]};
				`
			: css`
					color: ${theme.color.error[500]};
				`}
`;
export const TopWrapper = styled.div`
	display: flex;
	justify-content: space-between;
`;
export const Container = styled.div`
	display: flex;
	gap: 0.5rem;
	align-items: center;
`;
export const ErrorText = styled(TextV2)`
	color: ${({ theme }) => theme.color.error[500]};
`;
export const MiddleWrapper = styled.div``;
export const BottomWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;
export const SelectionWrapper = styled.div`
	display: flex;
	gap: 0.5rem;
`;
export const CheckboxWrapper = styled.div`
	display: flex;
	gap: 0.25rem;
	align-items: center;
`;
export const DocumentCardsWrapper = styled.div`
	overflow: auto;
	padding-bottom: 0.5rem;

	::-webkit-scrollbar {
		width: ${em(80)};
		height: ${em(4)};
	}

	::-webkit-scrollbar-thumb {
		background: ${defaultTheme.v2.color.neutral[400]};
		border-radius: 0.5rem;
	}

	::-webkit-scrollbar-thumb:hover {
		background-color: ${defaultTheme.v2.color.neutral[600]};
	}
`;
